import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { Layout, Row, Col, Flex, Typography, Card, Table } from 'antd';
import { getAppSettings } from '../../../selectors';

const { Content } = Layout;
const { Title, Paragraph } = Typography;

export const StyledWrapper = styled(Layout)`
  overflow: hidden;
  position: relative;
  height: max-content;
  min-height: 100%;
`;

export const StyledContent = styled(Content)`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  margin-bottom: 2rem;
`;

export const StyledFeatureCaption = styled(Flex)`
  padding: 2.4rem 0;
`;

const settingsTableColumns = [
  {
    title: 'Key',
    key: 'keyName',
    width: '30%',
    render: ({ keyName }: { keyName: string }) => (
      <Paragraph>{keyName}</Paragraph>
    ),
  },
  {
    title: 'Value',
    key: 'value',
    width: '70%',
    render: ({ keyName, value }: { keyName: string; value: string }) =>
      ['whiteLabelConfiguration', 'featureToggles'].includes(keyName) ? (
        <Paragraph>
          <pre>{value}</pre>
        </Paragraph>
      ) : (
        <Paragraph
          code
          copyable={[
            'organizationId',
            'merchantAccountId',
            'merchantId',
            'packageCode',
          ].includes(keyName)}
        >
          {value || 'undefined'}
        </Paragraph>
      ),
  },
];

export function Developer() {
  const settings = useSelector(getAppSettings);
  const dataSourceSettings = Object.entries(settings).map(([key, value]) => ({
    keyName: key,
    value: typeof value === 'string' ? value : JSON.stringify(value, null, 2),
  }));

  return (
    <StyledWrapper>
      <StyledContent>
        <Row>
          <Col span={24}>
            <StyledFeatureCaption justify="flex-start" vertical>
              <Title level={3} style={{ fontWeight: 400, margin: 0 }}>
                Developer Tools
              </Title>
              <Paragraph type="secondary">
                This page is intended for internal use only and is not meant for
                merchants. It provides developer-specific information useful for
                debugging or inspecting the current environment context.
              </Paragraph>
            </StyledFeatureCaption>
          </Col>
          <Col span={24}>
            <Card>
              <Row justify="space-between" align="middle" gutter={[16, 16]}>
                <Col span={24}>
                  <Title level={5} style={{ marginTop: 0 }}>
                    Settings Properties Passed by App Shell to Microfrontend
                    Applications
                  </Title>
                  <Paragraph type="secondary">
                    These are the setting property values for this merchant that
                    the App Shell passes to microfrontend applications to ensure
                    consistent behavior, communication, and seamless integration
                    across the system.
                  </Paragraph>
                </Col>
                <Col span={24}>
                  <Table
                    bordered
                    rowKey="keyName"
                    size="small"
                    pagination={false}
                    columns={settingsTableColumns}
                    dataSource={dataSourceSettings}
                  />
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </StyledContent>
    </StyledWrapper>
  );
}
